import TourContent from './tour-content'
import { Step } from './Mapper'
import { icon, iconMobile } from './icon-svg.js'
import { getStore } from '@/store/StoreInstance';
import image from './anna-from-qiagen--450px.png'

const getIntroHeader = (mobile) => {
  return `<span class="welcome-header">${!mobile ? icon : iconMobile}</span>`
}
const getStepHeader = (tour) => {
  let stepProgress = `${tour.steps.indexOf(tour.currentStep)+1} of ${tour.steps.length}`;
  return `
    <div class="custom-header">
    <div class="heading-container">
    <div class="img-circle">
      <img src="${image}" alt="anna from qiagen headshot">
    </div>
    <p class="img-heading">
        <span>Anna</span> from <span>QIAGEN</span>
        </p>
      </div>
      <div class="step-progress">${stepProgress}</div>
      </div>`
}

export default {
  createSteps: (tour, tourName, mobile) => {
    return TourContent[`${tourName}Tour`].map(item => {
      return new Step(tour, item, mobile);
    })
  },
  createHeader: (tour, currentStepElement, mobile) => {
    const header = currentStepElement.querySelector('.shepherd-header');
    const container = tour.currentStep.options.id === 'intro' ? getIntroHeader(mobile) : getStepHeader(tour)
    header.insertAdjacentHTML('afterbegin', container)
  },
  createFooter: (currentStepElement) => {
    const footer = currentStepElement.querySelector('.shepherd-footer');
    const rightSideBtns = footer.querySelectorAll('button.previous, button.next')

    if (rightSideBtns.length <= 1) return

    const wrapper = document.createElement('div')
    wrapper.classList.add("wrapper")

    Array.prototype.forEach.call(rightSideBtns, function(c){
      wrapper.appendChild(c);
    });
    footer.insertBefore(wrapper, footer.firstChild);
  },
  getTourStatus: () => {
    const tour = ['product', 'finder', 'workflow', 'eln']
      .map(type => ({[type]: JSON.parse(localStorage.getItem(`tour-${type}`) ?? 'false')}))
    for (const obj of tour)
    getStore().dispatch('tour/setTour', obj)
  }
}
